var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.19366C0.5 1.2796 1.23828 0.506165 2.1875 0.506165C3.10156 0.506165 3.875 1.2796 3.875 2.19366V5.00616H2.1875H1.625C0.992188 5.00616 0.5 4.51398 0.5 3.88116V2.19366ZM4.4375 0.506165H14C15.8633 0.506165 17.375 2.01788 17.375 3.88116V10.6312H11.5391C10.4141 10.6312 9.5 11.5804 9.5 12.7054V12.8812C9.5 14.1468 8.48047 15.1312 7.25 15.1312C5.98438 15.1312 5 14.1468 5 12.8812V2.19366C5 1.56085 4.78906 0.998352 4.4375 0.506165ZM16.8125 16.2562H13.4375H7.25C9.11328 16.2562 10.625 14.7444 10.625 12.8812V12.7054C10.625 12.178 11.0469 11.7562 11.5391 11.7562H20.1875C20.4688 11.7562 20.75 12.0374 20.75 12.3187C20.75 14.4984 18.957 16.2562 16.8125 16.2562Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default ForwardRef;